import Button from "@/common/Button";
import DropdownMenu from "@/common/DropdownMenu";
import { CategorySearchMenuType } from "@/types/Search";
import React, { useCallback, useState } from "react";
import { toast } from "react-toastify";
import ArrowDropdown from "../Svg/ArrowDropdown";
import InputText from "@/common/InputText";
import { SearchNormal1 } from "iconsax-react";
import CategoryItem from "../SearchFilter/CategoryItem";
import Spinner from "@/common/Spinner,";

function CategorySearchMenu({
  checkedItems,
  categoryMenuData,
  setCategoryMenuData,
  getCategoryForSearch,
  setCheckedItems,
  setCheckedNames,
}: CategorySearchMenuType) {
  const [isLoading, setIsLoading] = useState(false); // وضعیت لودینگ

  const handleSearchCategory = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      setIsLoading(true); // شروع لودینگ
      try {
        const response = await getCategoryForSearch({
          text: e?.target?.value,
        });
        if (response?.isSuccess) {
          setCategoryMenuData(response?.data);
        } else {
          toast.error("خطا در انجام عملیات");
        }
      } catch (err) {
        console.error("Error fetching category:", err);
      }
      setIsLoading(false); // پایان لودینگ
    },
    [getCategoryForSearch, setCategoryMenuData]
  );

  const handleCheckboxChange = (id: string, name: string) => {
    setCheckedItems((prev: Record<string, boolean>) => ({
      ...prev,
      [id]: !prev[id],
    }));
    setCheckedNames((prev) => {
      // بررسی وجود آیتم در آرایه
      const exists = prev.some((item) => item.id === id);

      if (exists) {
        // اگر قبلاً اضافه شده بود، حذفش کن
        return prev.filter((item) => item.id !== id);
      } else {
        // در غیر این صورت، اضافه‌اش کن
        return [...prev, { id, name }];
      }
    });
  };
  return (
    <DropdownMenu
      direction="rtl"
      menuClass="p-0 border top-14 right-14 rounded-3xl"
      customeClass="w-max py-1 px-1 rounded-lg bg-white "
      trigger={
        <Button variant="primary" className="h-8 px-3">
          <span className="text-lg ws-gray-500">{"دسته بندی"}</span>
          <ArrowDropdown />
        </Button>
      }
    >
      <div className="bg-white w-80  rounded-3xl p-3">
        <InputText
          placeholder="جستجو"
          className="h-10 search-input text-base  border-2 border-ws-gray-800 container-contact-input"
          containerClass="w-full  "
          badge={<SearchNormal1 color="#686868" size={18} />}
          badgeTextClass="pr-0 border-r-0"
          onChange={handleSearchCategory}
          type="search"
        />
        <div className="h-52 overflow-auto mt-3 cat-search">
          {isLoading ? (
            <div className="flex flex-col items-center justify-start gap-3 h-full">
              <Spinner />
              در حال بارگذاری...
            </div>
          ) : categoryMenuData?.length > 0 ? (
            categoryMenuData.map((category) => (
              <CategoryItem
                key={category.id}
                category={category}
                checkedItems={checkedItems}
                handleCheckboxChange={handleCheckboxChange}
              />
            ))
          ) : (
            <div className="text-gray-500 text-center mt-3">
              دیتایی موجود نیست
            </div>
          )}
        </div>
      </div>
    </DropdownMenu>
  );
}

export default CategorySearchMenu;
